{
	D.UploaderPar = function(){
	};
	D.UploaderPar.prototype.accept = null;
	D.UploaderPar.prototype.limit = -1;
	D.UploaderPar.prototype.thumbWidth = 0;
	D.UploaderPar.prototype.thumbHeight = 0;
	D.UploaderPar.prototype.thumbCrop = true;
	/** @type {Node|null} */
	D.UploaderPar.prototype.dropNode = null;
	/** @type {Function|null} */
	D.UploaderPar.prototype.onBeforeSelect = null;
	/** @type {Function|null} */
	D.UploaderPar.prototype.onSelect = null;
	/** @type {Function|null} */
	D.UploaderPar.prototype.onRemove = null;
	/** @type {Function|null} */
	D.UploaderPar.prototype.onUploadProgress = null;
	/** @type {Function|null} */
	D.UploaderPar.prototype.onUploadComplete = null;
	/** @type {Function|null} */
	D.UploaderPar.prototype.onUploadCompleteData = null;
	/** @type {Function|null} */
	D.UploaderPar.prototype.onUploadSecurityError = null;
	/** @type {Function|null} */
	D.UploaderPar.prototype.onUploadIOError = null;
	D.UploaderPar.prototype.onThumb = null;
	D.UploaderPar.prototype.onInit = null;
	// autoupload
	/** @type {Function|null} */
	D.UploaderPar.prototype.onGetUploadData = null;
	/** @type {Function|null} */
	D.UploaderPar.prototype.onListUploadComplete = null;
	D.UploaderPar.prototype.log = D.DEV;
	D.UploaderPar.prototype.compressionOptions = null;
	D.UploaderPar.prototype.capture = null;

	/**
	 * @param {Object|D.UploaderPar} par
	 * @constructor
	 */
	D.NativeUploader = function(par){
		par = par || {};
		/** @type {D.SortedMap.<D.NativeUploader.File>} */
		this._files = new D.SortedMap;
		/** @type {D.SortedMap.<D.NativeUploader.File>} */
		this._thumbFiles = new D.SortedMap;
		this.limit = isset( par.limit ) ? par.limit : -1;
		this.accept = par.accept || null;
		this.capture = par.capture || null;
		this.node = mkE( {
			tag:'div',
			className:'NativeUploader',
			els:[
				this._makeInput()
			]
		} );
		this.thumbWidth = par.thumbWidth || 0;
		this.thumbHeight = par.thumbHeight || 0;
		this.thumbCrop = par.thumbCrop || true;
		this.log = isset( par.log ) ? par.log : D.DEV;
		this.onBeforeSelect = par.onBeforeSelect || this.onBeforeSelect;
		this.onSelect = par.onSelect || this.onSelect;
		this.onRemove = par.onRemove || this.onRemove;
		this.onUploadProgress = par.onUploadProgress || this.onUploadProgress;
		this.onUploadComplete = par.onUploadComplete || this.onUploadComplete;
		this.onUploadCompleteData = par.onUploadCompleteData || this.onUploadCompleteData;
		this.onUploadIOError = par.onUploadIOError || this.onUploadIOError;
		this.onUploadSecurityError = par.onUploadSecurityError || this.onUploadSecurityError;
		this.onThumb = par.onThumb || this.onThumb;
		this.dropNode = par.dropNode || null;
		if( par.onInit ){
			setTimeout( D.closure( this, function(){
				par.onInit.call(this);
			} ), 10 );
		}
		// autoupload
		this.uploading = false;
		this.onGetUploadData = par.onGetUploadData || null;
		this.onListUploadComplete = par.onListUploadComplete || this.onListUploadComplete;
		this.compressionOptions = par.compressionOptions || null;
	};

	D.NativeUploader.prototype.append = function(parent){
		this.node.append(parent);
		if( this.dropNode ){
			this._addDragDropEvent();
		}
		return this;
	};

	/** @type {Object.<D.NativeUploader.File>|D.SortedMap} */
	D.NativeUploader.prototype._files = null;
	/** @type {Object.<D.NativeUploader.File>|D.SortedMap} */
	D.NativeUploader.prototype._thumbFiles = null;

	D.NativeUploader.prototype._log = function( par, v ){
		if( this.log ){
			if(v){
				D.log( par, v );
			} else {
				D.log(par);
			}
		}
	};

	D.NativeUploader.prototype._makeInput = function(){
		var attributes = {
			size: 50
		};
		if( this.accept ){
			attributes.accept = this.accept;
		}
		if( this.capture ){
			attributes.capture = this.capture;
		}
		this._fileInputNode = mkE( {
			tag:'input',
			type:'file',
			attr: attributes,
			prop:{
				onchange:D.closure( this, this._fileOnchange )
			}
		} );
		if( this.limit == -1 || this.limit > 1 ){
			this._fileInputNode.multiple = true;
		}
		return this._fileInputNode;
	};


	D.NativeUploader.prototype._fileOnchange = function(){
		var inp = this._fileInputNode;
		if( !inp.files.length ){
			return;
		}
		if( this.onBeforeSelect() === false ){
			this._makeInput().replace(inp);
			return;
		}
		this._makeInput().replace(inp);
		this._addFiles( inp.files );
	};

	D.NativeUploader.prototype._addFiles = function(files){
		for( var k = 0; k < files.length; ++ k ){
			if( this.limit != -1 && this._files.length() == this.limit ){
				continue;
			}
			var file = new D.NativeUploader.File( this, files[k] );
			if( !file.size ){
				continue;
			}
			this._files.set( file.id, file );
			var onSelectPar = {
				id:file.id,
				name:file.name,
				size:file.size
			};
			if( this._onSelect(onSelectPar) === false ){
				this._files.del( file.id );
				continue;
			}
			if( this.thumbWidth && this.thumbHeight ){
				this._thumbFiles.set( file.id, file );
				this._getThumbs();
			}
		}
		this.listUpload();
	};

	D.NativeUploader.prototype.onBeforeSelect = function(){
	};

	D.NativeUploader.prototype._onSelect = function(file){
		return this.onSelect(file);
		//if( re !== false && this.onGetUploadData ){
		//	this.listUpload();
		//}
		//return re;
	};

	D.NativeUploader.prototype.onSelect = function(file){
	};

	D.NativeUploader.prototype.onRemove = function(file){
	};

	D.NativeUploader.prototype.onUploadProgress = function(){
	};

	D.NativeUploader.prototype._onUploadComplite = function(file){
		this._log( 'onUploadComplete', file );
		this.onUploadComplete(file);
	};

	D.NativeUploader.prototype.onUploadComplete = function(file){
	};

	D.NativeUploader.prototype._onUploadCompliteData = function(file){
		this._log( 'onUploadCompleteData', file );
		this.onUploadCompleteData(file);
		if( this.onGetUploadData ){
			if( this.uploading ){
				this.uploading = false;
				this.listUpload();
			}
			if( !this.uploading && empty( this.list() ) ){
				this._log('onListUploadComplete');
				this.onListUploadComplete();
			}
		}
	};

	D.NativeUploader.prototype.onUploadCompleteData = function(file){
	};

	D.NativeUploader.prototype.onUploadIOError = function(){
	};

	D.NativeUploader.prototype.onUploadSecurityError = function(){
	};

	D.NativeUploader.prototype.onListUploadComplete = function(){
	};

	D.NativeUploader.prototype._onThumb = function(par){
		this._log( 'onThumb', par );
		this._getThumbsProcess = false;
		this._getThumbs();
		this.onThumb(par);
	};

	D.NativeUploader.prototype.onThumb = function(par){
	};

	D.NativeUploader.prototype._getThumbs = function(){
		if( this._getThumbsProcess ){
			return;
		}
		this._getThumbsProcess = true;
		/** @type {D.NativeUploader.File} file */
		var file = this._thumbFiles.shift();
		if(!file){
			this._getThumbsProcess = false;
			return;
		}
		if( file.type.match(/image.*/) ){
			file._getThumb();
			return;
		}
		this._getThumbsProcess = false;
		this._getThumbs();
	};

	/** upload
	 @id - file id
	 @url - upload url
	 @data - post data
	 */
	D.NativeUploader.prototype.upload = function(par){
		this._log( 'upload', par );
		/** @type {D.NativeUploader.File} */
		var file = this._files.get( par.id );
		if(!file){
			return false;
		}
		if( typeof par.data != 'object' ){
			delete par.data;
		}
		par.data = par.data || {};
		par.data.uploadFlash = 1;
		if( file.upload(par) ){
			this._files.del( file.id );
			return true;
		}
		return false;
	};

	D.NativeUploader.prototype.remove = function(id){
		this._thumbFiles.del(id);
		var file = this._files.get(id);
		if(!file){
			return;
		}
		this._files.del(id);
		this.onRemove(file);
		if( file._xhr ){
			file._xhr.abort();
		}
		if( this.onGetUploadData && this.uploading && p.id == this.uploading.id ){
			this.uploading = false;
			this.listUpload();
		}
	};

	D.NativeUploader.prototype.count = function(){
		return count( this._files );
	};

	D.NativeUploader.prototype.list = function(){
		return this._files.toObject();
	};

	D.NativeUploader.prototype.clear = function(){
		this._files.each( function( k, file ){
			if( file._xhr ){
				file._xhr.abort();
			}
		} );
		this._files.clear();
		this._thumbFiles.clear();
	};

	D.NativeUploader.prototype.listUpload = function(){
		if( !this.onGetUploadData ){
			return false;
		}
		if( this.uploading ){
			return false;
		}
		this.uploading = reset( this.list() );
		if( !this.uploading ){
			return false;
		}
		var data = this.onGetUploadData( this.uploading );
		if( typeof data != 'object' || !data.url ){
			D.console.error( 'Uploader.onGetUploadData return error:', data );
			this.uploading = false;
			return false;
		}
		data.id = this.uploading.id;
		this.upload(data);
		return true;
	};

	D.NativeUploader.prototype._addDragDropEvent = function(){
		this._dropOverlayNode = mkE( {
			tag:'div',
			className:'NativeUploaderDrop',
			els:[
				{
					tag:'div',
					text:'upload_hover_msg'
				}
			]
		} );
		window.addEventListener( 'dragenter', this._onDragEnter = D.closure( this, this._onDragEnter ), false );
		window.addEventListener( 'dragover', this._onDragOver = D.closure( this, this._onDragOver ), false );
		window.addEventListener( 'dragleave', this._onDragLeave = D.closure( this, this._onDragLeave ), false );
		this.dropNode.addEventListener( 'dragover', this._onDragOver, false );
		this.dropNode.addEventListener( 'drop', this._onDrop = D.closure( this, this._onDrop ), false );
	};

	D.NativeUploader.prototype._removeDragDropEvent = function(){
		window.removeEventListener( 'dragenter', this._onDragEnter, false );
		window.removeEventListener( 'dragover', this._onDragOver, false );
		window.removeEventListener( 'dragleave', this._onDragLeave, false );
		this.dropNode.removeEventListener( 'dragover', this._onDragOver, false );
		this.dropNode.removeEventListener( 'drop', this._onDrop, false );
		this._log( 'unbind drag events', this );
	};

	D.NativeUploader.prototype._dragIsFiles = function(e){
		var types = e.dataTransfer.types;
		if(!types){
			return false;
		}
		if( types.contains ){
			return types.contains('Files');
		}
		var isFiles = false;
		for( var i = 0; i < types.length; ++ i ){
			if( types[i] == 'Files' ){
				isFiles = true;
				break;
			}
		}
		return isFiles;
	};

	D.NativeUploader.prototype._onDragEnter = function(e){
		if( !this._dragIsFiles(e) ){
			return;
		}
		if( !document.body.contains(this.node) ){
			this._removeDragDropEvent();
			return;
		}
		if( !this._dropOverlayNode.parentNode ){
			this._dropOverlayNode.append( this.dropNode );
			addClassName(this.dropNode, 'uploaderDropOver');
		}
	};

	D.NativeUploader.prototype._onDragOver = function(e){
		if( !this._dragIsFiles(e) ){
			return;
		}
		e.stopPropagation();
		e.preventDefault();
		clearTimeout( this._dropOverlayTO );
	};

	D.NativeUploader.prototype._onDragLeave = function(e){
		this._dropOverlayTO = setTimeout( D.closure( this, this._dropOverlayRemove ), 50 );
	};

	D.NativeUploader.prototype._dropOverlayRemove = function(){
		this._dropOverlayNode.remove();
		removeClassName(this.dropNode, 'uploaderDropOver');
	};

	D.NativeUploader.prototype._onDrop = function(e){
		e.stopPropagation();
		e.preventDefault();
		this._dropOverlayNode.remove();
		removeClassName(this.dropNode, 'uploaderDropOver');
		if( !e.dataTransfer.files ){
			return;
		}
		var fls = e.dataTransfer.files;
		var files = [];
		for( var k = 0; k < fls.length; ++ k ){
			files.push( fls[k] );
		}
		files.sort( function( a, b ){
			if( a.name == b.name ){
				return 0;
			}
			return a.name > b.name ? 1 : -1;
		} );
		D.log(files);
		if( this.onBeforeSelect() === false ){
			return;
		}
		this._addFiles(files);
	};

	/**
	 * @constructor
	 * @param {D.NativeUploader} uploader
	 * @param {File} file
	 */
	D.NativeUploader.File = function( uploader, file ){
		this._uploader = uploader;
		this._file = file;
		this.id = ++ this.constructor._n;
		this.name = file.name;
		this.size = file.size;
		this.type = file.type;
	};

	D.NativeUploader.File._n = 0;
	/** @type {File} */
	D.NativeUploader.File.prototype._file = null;
	D.NativeUploader.File.prototype.id = 0;
	D.NativeUploader.File.prototype.name = '';
	D.NativeUploader.File.prototype.size = 0;
	D.NativeUploader.File.prototype.type = '';
	D.NativeUploader.File.prototype.data = null;

	D.NativeUploader.File.prototype.upload = async function(par){
		if( this._xhr ){
			return false;
		}

		if (this._uploader.compressionOptions) {
			try {
				this._file = await this.compress();
				this._uploader._log(this.name, `compressed ${this._file.size / 1024 / 1024} MB`);
			} catch (e) {
				this._uploader.onUploadIOError({
					id: this.id,
					error: 'compression_error',
					details: e
				});
				return false;
			}
		}

		this._xhr = new XMLHttpRequest;
		this._xhr.upload.addEventListener( 'progress', D.closure( this, this._onProgress ), false );
		this._xhr.upload.addEventListener( 'load', D.closure( this, this._onUpload ), false );
		this._xhr.addEventListener( 'load', D.closure( this, this._onLoad ), false );
		this._xhr.addEventListener( 'error', D.closure( this, this._onError ), false );
		this._xhr.open( 'POST', par.url, true );

		var formData = new FormData();
		if(par.fileName) {
			formData.append("Filedata", this._file, par.fileName);
		} else {
			formData.append("Filedata", this._file);
		}
		if( par.data ){
			for( var k in par.data ){
				formData.append( k, par.data[k] );
			}
		}
		this._xhr.send(formData);
		return true;
	};

	D.NativeUploader.File.prototype.compress = function() {
		return new Promise((resolve, reject) => {
			D.addJS(
				'/dist/vendor/browser-image-compression/browser-image-compression.js',
				() => {
					try {
						let compressionOptions = Object.assign({}, this._uploader.compressionOptions);
						compressionOptions.onProgress = (percent) => {
							this._uploader._log(this.name, `Compression: ${percent}%`);
							this._uploader.onUploadProgress({
								id: this.id,
								percent: percent,
								type: 'compression'
							});
						};
						let file = imageCompression(this._file, compressionOptions)
						resolve(file);
					} catch (e) {
						reject(e);
					}
				});
		});
	};

	/** @type {D.NativeUploader} */
	D.NativeUploader.File.prototype._uploader = null;

	D.NativeUploader.File.prototype._onProgress = function(e){
		var p = {
			id:this.id,
			bytesLoaded:e.loaded,
			bytesTotal:( e.total || this.size ),
			type: 'upload'
		};
		p.percent = Math.round( p.bytesLoaded / p.bytesTotal * 100 );
		this._uploader._log( this.name, p.bytesLoaded / p.bytesTotal );
		this._uploader.onUploadProgress(p);
	};

	D.NativeUploader.File.prototype._onUpload = function(){
		this._uploader._onUploadComplite(this);
	};

	D.NativeUploader.File.prototype._onLoad = function(e){
		this.data = this._xhr.response || this._xhr.responseText;
		this._uploader._onUploadCompliteData(this);
		this._xhr = null;
	};

	D.NativeUploader.File.prototype._onError = function(e){
		this._uploader.onUploadIOError( {
			id:this.id,
			error:'error',
			details: e
		} );
	};

	D.NativeUploader.File.prototype._getThumb = function(){
		var reader = new FileReader;
		reader.onload = D.closure( this, this._fileOnload );
		reader.readAsDataURL( this._file );
	};

	D.NativeUploader.File.prototype._fileOnload = function(e){
		var img = new Image();
		img.onload = D.closure( this, this._imageOnload, img );
		img.src = e.target.result;
	};

	D.NativeUploader.File.prototype._imageOnload = function(img){
		var w = this._uploader.thumbWidth;
		var h = this._uploader.thumbHeight;
		var canvas = mkE( {
			tag:'canvas'
		} );
		if( this._uploader.thumbCrop ){
			var k = Math.max( w / img.width, h / img.height );
		} else {
			var k = Math.min( w / img.width, h / img.height );
		}
		var rw = img.width * k;
		var rh = img.height * k;
		var context;
		if( this._uploader.thumbCrop ){
			canvas.width = w;
			canvas.height = h;
			context = canvas.getContext('2d');
			context.clearRect( 0, 0, w, h );
			context.drawImage( img, ( w - rw ) / 2, ( h - rh ) / 2, rw, rh );
		} else {
			canvas.width = rw;
			canvas.height = rh;
			context = canvas.getContext('2d');
			context.clearRect( 0, 0, rw, rh );
			context.drawImage( img, 0, 0, rw, rh );
		}
		var u = canvas.toDataURL( 'image/jpeg', 1.0 );
		this._uploader._onThumb( {
			id:this.id,
			url:u,
			data:u.substr( u.indexOf(',') + 1 )
		} );
	};
	window.Uploader = D.NativeUploader;
}